// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"3d7f264e","453":"0acdab7a","850":"2977ac44","873":"e747636d"}[chunkId] + ".chunk.js";
};